<template>
  <div class="h-full">
    <vx-card class="h-full" id="print-approval" :style="isPrint ? { boxShadow: 'none', borderRadius: '0' } : {}">
      <!--임시저장 문서일 경우 안내와 컨트롤-->
      <temp-document-alert v-if="!isPrint && board.statusCode === 'temp'" :is-writer="board.isWriter" @click-upload="handleClickUpload" />

      <vs-row v-else-if="board && board.savable && board.isWriter">
        <vs-col class="w-full pr-2">
          <div v-if="isPrint" style="display: inline-flex; align-items: center">
            <img src="@/assets/images/icon/red_exclamation.svg" />
            <span style="color: #e42728; padding-left: 10px; font-size: 17px">결재 절차가 이루어지지 않은 임시저장 문서입니다.</span>
          </div>
          <vs-button v-else class="w-full" color="secondary" @click="handleClickUpload">결재품의</vs-button>
        </vs-col>
      </vs-row>

      <vs-row v-if="board && board.isTurnApproval" class="flex gap-2">
        <vs-col class="flex-1">
          <vs-button class="w-full" color="secondary" @click="handleClickOk">승인</vs-button>
        </vs-col>
        <vs-col class="flex-1">
          <vs-button class="w-full" color="#EDEDED" text-color="black" @click="handleClickNo">반려</vs-button>
        </vs-col>
      </vs-row>

      <div style="page-break-after: always"></div>


      <!-- 결재 프로세스 -->
      <vs-row class="side-item-title py-4 flex" vs-align="flex-end">
        <h5>{{발주부서표시하는가 ? '작성업체/부서' : '결재 프로세스'}}</h5>
        <vs-button v-if="board && !board.readonly" class="small p-2 ml-auto" color="secondary" @click="showApprovalPopup">결재선 지정 </vs-button>
      </vs-row>

      <vs-row v-if="(!approvalLine || approvalLine.length === 0) && board && board.writer" class="side-item border-bottom">
        <vs-col class="w-full my-3">
          <vs-col class="w-5/12" vs-align="center" vs-type="flex">
            <span style="min-width: 42px"><vs-avatar class="flex" /></span>
            <span style="line-height: 1">
              {{ board.writer.name }}
              <br />
              <span style="font-size: 11px">{{ getSectionDepartment(board.writer) }}</span>
            </span>
          </vs-col>
          <vs-col class="w-7/12 h-full" vs-align="center" vs-justify="flex-end" vs-type="flex">
            <span class="w-1/2 text-center"></span>
            <span class="btn-border btn-border-0 ml-6">기안</span>
          </vs-col>
        </vs-col>
      </vs-row>

      <div>
        <!-- 기안자 - 발주부서 -->
        <div v-if="발주부서표시하는가 && board && board.writer && approvalLine && approvalLine.length > 0">
          <vs-row  class="side-item border-bottom">
            <vs-col class="w-full my-3" vs-type="flex" vs-justify="space-between">
              <vs-col class="w-full flex-1" vs-align="center" vs-type="flex">
                <span style="min-width: 42px"><vs-avatar class="flex" /></span>
                <div style="line-height: 1">
                  <div>{{ board.writer.name }}{{ board.writer.rank ? ` (${board.writer.rank})` : "" }}</div>
                  <div class="mt-1" style="font-size: 12px">{{ getSectionDepartment(board.writer) }}</div>
                  <div class="mt-2" style="font-size: 10px">
                    <span class="text-center date">{{ getDate(상신자.updated_at) }}</span>
                    <span class="text-center time ml-2">{{ getTime(상신자.updated_at) }}</span>
                  </div>
                </div>
              </vs-col>
              <div class="flex h-full items-center">
                <span class="btn-border btn-border-0 ml-6">기안</span>
              </div>
            </vs-col>
          </vs-row>
        </div>

        <!-- 결재 프로세스 -->
        <vs-row class="side-item-title pt-8 pb-4" v-if="발주부서표시하는가 && approvalLine && approvalLine.length > 0">
          <h5>{{ 발주부서레이블 }}</h5>
        </vs-row>
        <div v-for="(member, index) in approvalLine.slice().reverse()" :key="'approval_' + index">
          <vs-row v-if="member.type_code === 'approval' && !member.document_company_id /*처리부서 인원 제외*/" class="side-item" :class="[Number(member.status_id) !== 3 ? 'border-bottom' : '']">
            <vs-col class="w-full my-3" vs-type="flex" vs-justify="space-between">
              <vs-col class="w-full flex-1" vs-align="center" vs-type="flex">
                <span style="min-width: 42px"><vs-avatar class="flex" /></span>
                <div style="line-height: 1">
                  <div>{{ member.user_name }}{{ member.rank ? ` (${member.rank})` : "" }}</div>
                  <div class="mt-1" style="font-size: 12px">{{ getSectionDepartment(member) }}</div>
                  <div v-if="Number(member.status_id) !== 1/*대기*/" class="mt-2" style="font-size: 10px">
                    <span class="text-center date">{{ getDate(member.updated_at) }}</span>
                    <span class="text-center time ml-2">{{ getTime(member.updated_at) }}</span>
                  </div>
                </div>
              </vs-col>
              <div v-if="member.show_status_tag" class="flex h-full items-center">
                <span class="btn-border ml-6" :class="'btn-border-' + getStatusNum(member, member.status_id)" style="min-width: 55px">{{ getStatusName(getStatusNum(member, member.status_id)) }}</span>
              </div>
            </vs-col>
          </vs-row>

          <!-- 반려 -->
          <vs-row v-if="Number(member.status_id) === 3/*반려*/" class="side-item border-bottom">
            <vs-col class="w-full mb-2" v-if="member.comments.length > 0">
              <div class="flex px-3 py-2" style="border: 1px dashed #aaa; border-radius: 4px; background-color: #eee;">{{ member.comments[0].comment }}</div>
            </vs-col>
          </vs-row>
        </div>

        <div v-if="발주부서표시하는가 === false && board && board.writer && approvalLine && approvalLine.length > 0">
          <vs-row  class="side-item border-bottom">
            <vs-col class="w-full my-3" vs-type="flex" vs-justify="space-between">
              <vs-col class="w-full flex-1" vs-align="center" vs-type="flex">
                <span style="min-width: 42px"><vs-avatar class="flex" /></span>
                <div style="line-height: 1">
                  <div>{{ board.writer.name }}{{ board.writer.rank ? ` (${board.writer.rank})` : "" }}</div>
                  <div class="mt-1" style="font-size: 12px">{{ getSectionDepartment(board.writer) }}</div>
                  <div class="mt-2" style="font-size: 10px">
                    <span class="text-center date">{{ getDate(상신자.updated_at) }}</span>
                    <span class="text-center time ml-2">{{ getTime(상신자.updated_at) }}</span>
                  </div>
                </div>
              </vs-col>
              <div class="flex h-full items-center">
                <span class="btn-border btn-border-0 ml-6">기안</span>
              </div>
            </vs-col>
          </vs-row>
        </div>


        <!-- 처리부서 (게시판 옵션 useDocumentCompany: false 면 표시하지 않음) -->
        <template v-if="documentCompany && useDocumentCompany">
          <vs-row class="side-item-title pt-8 pb-4" v-if="documentCompanyMembers.length > 0">
            <h5>{{ 처리부서레이블 }} ({{ documentCompany.label }})</h5>
          </vs-row>
          <vs-row v-else>
            <vs-row class="side-item-title pt-8 pb-4 justify-between">
              <h5>{{ 처리부서레이블 }}</h5>
              <h5>{{ documentCompany.label }}</h5>
            </vs-row>
            <vs-col class="w-full mt-2 mb-2">
              <div class="flex px-3 py-4 justify-center" style="border: 1px dashed #aaa; border-radius: 4px; background-color: #eee;">
                아직 {{ 처리부서레이블 }} 결재자가 지정되지 않았습니다.
              </div>
            </vs-col>
          </vs-row>
          <div v-for="(item, index) in documentCompanyMembers" :key="'document_company_' + index">
            <vs-row class="side-item border-bottom">
              <vs-col class="w-full my-3" vs-type="flex" vs-justify="space-between">
                <vs-col class="w-full flex-1" vs-align="center" vs-type="flex">
                  <span style="min-width: 42px"><vs-avatar class="flex" /></span>
                  <div style="line-height: 1">
                    <div>{{ item.user_name }}{{ item.rank ? ` (${item.rank})` : "" }}</div>
                    <div class="mt-1" style="font-size: 12px">{{ getSectionDepartment(item) }}</div>
                    <div v-if="Number(item.status_id) !== 1/*대기*/" class="mt-2" style="font-size: 10px">
                      <span class="text-center date">{{ getDate(item.updated_at) }}</span>
                      <span class="text-center time ml-2">{{ getTime(item.updated_at) }}</span>
                    </div>
                  </div>
                </vs-col>
                <div v-if="item.show_status_tag" class="flex h-full items-center">
                  <span class="btn-border ml-6" :class="'btn-border-' + getStatusNum(item, item.status_id)" style="min-width: 55px">{{ getStatusName(getStatusNum(item, item.status_id)) }}</span>
                </div>
              </vs-col>
            </vs-row>
          </div>
        </template>

        <!-- 수신참조 -->
        <vs-row class="side-item-title pt-8 pb-4" v-if="referenceCount > 0 || (referenceCompanies && referenceCompanies.length > 0)">
          <h5>수신참조</h5>
        </vs-row>

        <!-- 수신참조 부서 먼저 표시 -->
        <div v-if="referenceCompanies && referenceCompanies.length > 0">
          <vs-row v-for="(company, cIndex) in referenceCompanies" :key="'reference_company_' + cIndex" class="side-item border-bottom">
            <vs-col class="w-full my-3" vs-type="flex" vs-justify="space-between">
              <vs-col class="w-full flex-1" vs-align="center" vs-type="flex">
                <span style="min-width: 42px"><vs-avatar class="flex" /></span>
                <div style="line-height: 1">
                  <div>{{ company.label }}</div>
                  <div class="mt-1" style="font-size: 12px">{{ getFullPathWithArrow(company.full_label) }}</div>
                </div>
              </vs-col>
              <div class="flex h-full items-center"></div>
            </vs-col>
          </vs-row>
        </div>

        <!-- 수신참조 사용자 표시 -->
        <div v-for="(item, index) in approvalLine" :key="'reference_' + index">
          <vs-row v-if="item.type_code === 'reference'" class="side-item border-bottom">
            <vs-col class="w-full my-3" vs-type="flex" vs-justify="space-between">
              <vs-col class="w-full flex-1" vs-align="center" vs-type="flex">
                <span style="min-width: 42px"><vs-avatar class="flex" /></span>
                <div style="line-height: 1">
                  <div>{{ item.user_name }}{{ item.rank ? ` (${item.rank})` : "" }}</div>
                  <div class="mt-1" style="font-size: 12px">{{ getSectionDepartment(item) }}</div>
                </div>
              </vs-col>
              <div class="flex h-full items-center"></div>
            </vs-col>
          </vs-row>
        </div>

        <!-- 회람자 -->
        <vs-row class="side-item-title pt-8 pb-4" v-if="circulationCount > 0">
          <h5>회람자</h5>
        </vs-row>

        <div v-for="(item, index) in approvalLine" :key="'circulation_' + index">
          <vs-row v-if="item.type_code === 'circulation'" class="side-item border-bottom">
            <vs-col class="w-full my-3" vs-type="flex" vs-justify="space-between">
              <vs-col class="w-full flex-1" vs-align="center" vs-type="flex">
                <span style="min-width: 42px"><vs-avatar class="flex" /></span>
                <div style="line-height: 1">
                  <div>{{ item.user_name }}{{ item.rank ? ` (${item.rank})` : "" }}</div>
                  <div class="mt-1" style="font-size: 12px">{{ getSectionDepartment(item) }}</div>
                </div>
              </vs-col>
              <div class="flex h-full items-center"></div>
            </vs-col>
          </vs-row>
        </div>

        <!-- 댓글 리스트-->
        <div v-if="commentList && commentList.length > 0" class="border-top" style="margin-top: 100px; margin-left: -1.5rem; margin-right: -1.5rem; padding-left: 1.5rem; padding-right: 1.5rem">
          <vs-row v-for="(comment, index) in commentList" :key="index" class="side-item pt-4" :class="index < commentList.length - 1 ? 'border-bottom' : ''">
            <vs-col class="w-full" vs-align="center" vs-type="flex">
              <span style="min-width: 42px"><vs-avatar class="flex" /></span>
              <span class="">
                <p>{{ comment.user_name }}</p>
                <h5 class="mb-2">
                  {{ comment.created_at ? comment.created_at.substr(0, 10) : "" }}<span style="color: #aaa; font-weight: 300">{{ comment.created_at ? comment.created_at.substr(10) : "" }}</span>
                </h5>
              </span>
            </vs-col>
            <vs-col class="w-full my-3">
              <div class="flex">
                <p>{{ comment.comment_content }}</p>
                <p v-if="!isPrint" class="ml-auto text-right" style="min-width: 75px; width: 75px">
                  <span v-if="commentabled && isCommentUpdateMode && comment.user_id === userId && comment.comment_id === updateCommentId" class="font-bold" style="font-size: 12px; cursor: pointer" @click="updateCommentModeCancel"
                    >취소</span
                  >
                  <span
                    v-if="commentabled && !isCommentUpdateMode && comment.user_id === userId"
                    class="font-bold"
                    style="font-size: 12px; cursor: pointer"
                    @click="
                      () => {
                        updateCommentMode(comment.comment_id, comment.comment_content);
                      }
                    "
                    >수정</span
                  >
                  <span
                    v-if="commentabled && !isCommentUpdateMode && comment.user_id === userId"
                    class="ml-4 font-bold"
                    style="font-size: 12px; cursor: pointer"
                    @click="
                      () => {
                        deleteComment(comment.comment_id);
                      }
                    "
                    >삭제</span
                  >
                </p>
              </div>
            </vs-col>
          </vs-row>
        </div>

        <!-- 댓글 작성 -->
        <div v-if="commentabled && !isPrint" class="border-top mt-10" style="margin-left: -1.5rem; margin-right: -1.5rem; padding: 1rem 1.5rem; padding-bottom: 0rem">
          <vs-row class="side-item">
            <vs-col class="w-full my-3 flex" vs-align="center">
              <span style="min-width: 42px"><vs-avatar class="flex" /></span>
              <span class="mr-2 w-full"><ml-input class="w-full" v-model="comment" /></span>
              <vs-button v-if="isCommentUpdateMode" class="px-4" style="min-width: 60px" @click="updateComment">수정 </vs-button>
              <vs-button v-else class="px-4" color="secondary" style="min-width: 60px" @click="addComment">입력</vs-button>
            </vs-col>
          </vs-row>
        </div>
      </div>
    </vx-card>

    <popup-approval-process ref="popupApprovalProcess" v-model="approvalLine" :show-popup="showPopup" :enabled="true" :board="board"
                            :document-company.sync="documentCompany" :reference-companies.sync="referenceCompanies" @sendApprovalList="handleSendApprovalProcess"
                            @closePopup="handleCloseApprovalPopup"/>
  </div>
</template>

<script>
import PopupApprovalProcess from "@/views/approval/PopupApprovalProcess";
import TempDocumentAlert from "@/views/modules/components/TempDocumentAlert.vue";
import * as UiUtil from "@/util/UiUtil";

export default {
  name: "ApprovalProcessModule",
  components: {
    TempDocumentAlert,
    PopupApprovalProcess,
  },
  props: {
    isPrint: Boolean,
    board: Object, // 문서정보
    commentabled: false, // 댓글사용여부
  },

  watch: {
    board: {
      deep: true,
      handler(board) {
        this.initApprovalList(board.approvalLine, board.documentCompany, board.referenceCompanies);
        this.loadCommentList();

        /**
         * 기본 처리부서 정보가 로드되었다면 자동 설정을 시도한다
         */
        if (this.isDefaultDocumentCompanyLoaded) {
          this.trySetDefaultDocumentCompany();
        }

        /**
         * 처리부서 팀장을 자동으로 지정한다.
         */
        if (this.isDocumentCompanyTurn()
          && !this.hasInsertDocumentCompanyChief // 아직 팀장이 추가되지 않았어야 한다
          && this.documentCompany  // 처리부서가 지정되어 있어야 한다
          && this.documentCompany.id // 처리부서가 지정되어 있어야 한다
          && this.board.statusCode === 'ongoing' // 진행중인 문서여야 한다
          && this.userInfo.virtual_company_id === this.documentCompany.virtual_company_id /*현재 사용자의 virtual_company_id === documentCompany.id 여야 한다*/) {
          // 중복 조회 방지
          this.hasInsertDocumentCompanyChief = true;

          // API에서 팀장을 검색한다
          this.$store.dispatch('approval/GET_VIRTUAL_COMPANY_CHIEF', {
            code: this.documentCompany.code,
          }).then((chiefInfo) => {
            if (chiefInfo && chiefInfo.virtual_company) {
              this.$nextTick(() => {

                // 현재 사용자가 팀장인지 확인한다
                let isChief = false;
                if (this.userInfo.id === chiefInfo.id) {
                  isChief = true;
                }

                // 현재 사용자를 처리부서 대기자에 추가한다.
                if (isChief === false) {
                  this.approvalLine.push({
                    document_company_id: this.documentCompany.id,
                    document_company_code: this.documentCompany.code,
                    company_id: this.userInfo.company_id,
                    section: this.userInfo.section,
                    department: this.userInfo.department,
                    status_code: 'wait',
                    status_id: 1, // 대기
                    status_name: '대기',
                    type_code: "approval",
                    type_id: 3,
                    type_name: '결재',
                    user_id: this.userId,
                    user_name: this.userInfo.name,
                    position: this.userInfo.position,
                    rank: this.userInfo.rank,
                    show_status_tag: true,
                  });
                }

                // 팀장 정보를 추가한다.
                this.approvalLine.push({
                  document_company_id: this.documentCompany.id,
                  document_company_code: this.documentCompany.code,
                  company_id: chiefInfo.company_id,
                  section: chiefInfo.section,
                  department: chiefInfo.department,
                  status_code: 'wait',
                  status_id: 1, // 대기
                  status_name: '대기',
                  type_code: "approval",
                  type_id: 3,
                  type_name: '결재',
                  user_id: chiefInfo.id,
                  user_name: chiefInfo.name,
                  position: chiefInfo.position,
                  rank: chiefInfo.rank,
                  show_status_tag: true,
                });

                // 결재선 표시를 업데이트한다
                this.initApprovalList(this.approvalLine, this.documentCompany, this.referenceCompanies);

                // 전달되는 결재선의 0번째에는 기안자가 들어가야 한다.
                const sendApprovalList = [];
                const registerItem = this.board.approvalLine[0];
                if (registerItem) sendApprovalList.push(registerItem);
                sendApprovalList.push(...this.approvalLine);

                this.$emit("handleSendApprovalProcess", sendApprovalList, this.documentCompany, this.referenceCompanies);
              });
            }
          }).catch(() => {})
        }
      },
    },

    /**
     * 기본 처리부서 정보가 준비되면 자동으로 처리부서를 설정한다
     */
    defaultDocumentCompany: {
      handler(newValue) {
        if (newValue) {
          this.trySetDefaultDocumentCompany();
        }
      },
    },
  },

  computed: {
    userInfo() {
      return this.$store.state.auth.userInfo;
    },

    boardId() {
      return parseInt(this.$route.params.boardId);
    },

    /**
     * 현재 사업장 ID를 반환 (board.stdInfo.field_id에서 가져옴)
     */
    fieldId() {
      return this.board && this.board.stdInfo ? this.board.stdInfo.field_id || 0 : 0;
    },

    /**
     * 기본 처리부서 정보를 반환 (독립적으로 계산)
     */
    defaultDocumentCompany() {
      if (!this.fieldId || !this.isDefaultDocumentCompanyLoaded) {
        return null;
      }

      let foundVirtualCompany = null;
      for (const item of this.defaultDocumentCompanyInfo) {
        if (Number(item.field_id) === Number(this.fieldId)) {
          foundVirtualCompany = item.virtual_company;
          break;
        }
      }

      return foundVirtualCompany;
    },

    /**
     * 처리부서에 지정된 회원만 필터링
     * 순서는 역순으로
     */
    documentCompanyMembers() {
      const members = this.approvalLine.filter((item) => item.document_company_id) || [];
      return members.reverse();
    },

    발주부서표시하는가() {
      if (this.boardId === 845) {
        return true
      } else {
        return false
      }
    },

    발주부서레이블() {
      return this.boardId === 845 ? '승인부서' : '발주부서';
    },

    // 게시판 결재 옵션에서 처리부서를 쓰지 않도록 지정했는지 (tab-items.js approvalOptions.useDocumentCompany)
    useDocumentCompany() {
      return !(this.board && this.board.approvalOptions && this.board.approvalOptions.useDocumentCompany === false);
    },
    처리부서레이블() {
      return this.boardId === 845 ? '확인부서' : '처리부서';
    }
  },
  data() {
    return {
      userId: 0,
      isCommentUpdateMode: false, //댓글 수정상태인가
      updateCommentId: "", //수정하려는 댓글 ID

      boardInfo: {},
      showPopup: false,
      approvalLine: [],
      documentCompany: null,  // 처리부서
      referenceCompanies: [], // 수신참조 부서
      documentCompanyCount: 0,
      referenceCount: 0,
      circulationCount: 0,
      nowChecker: {}, //결재자
      commentList: [], //댓글리스트
      comment: "",
      상신자: {},

      /**
       * 결재선 지정 팝업에서 처리부서 결재자 추가 여부
       */
      hasInsertDocumentCompanyChief: false,

      /**
       * 기본 처리부서 정보 (독립적으로 관리)
       */
      defaultDocumentCompanyInfo: [],
      isDefaultDocumentCompanyLoaded: false,
    };
  },
  async created() {
    this.initApprovalList(this.board.approvalLine, this.board.documentCompany, this.board.referenceCompanies);
    this.boardInfo = this.board;

    if (this.$store.state.auth.userInfo === null) {
      await this.$store.dispatch("USER_INFO");
    }
    this.userId = this.$store.state.auth.userInfo.id;

    // 기본 처리부서 정보를 독립적으로 로드
    await this.loadDefaultDocumentCompanyInfo();
  },
  methods: {
    /**
     * 기본 처리부서 정보를 독립적으로 로드한다
     */
    async loadDefaultDocumentCompanyInfo() {
      try {
        const hostname = window.location.hostname;
        const cacheKey = `${hostname}_기본처리부서.3`;
        const cached = localStorage.getItem(cacheKey);

        if (cached) {
          const parsed = JSON.parse(cached);
          // 캐시가 1시간(3600초) 이내면 사용
          if (new Date().getTime() - parsed.timestamp < 3600 * 1000) {
            this.defaultDocumentCompanyInfo = parsed.data;
            this.isDefaultDocumentCompanyLoaded = true;
            this.trySetDefaultDocumentCompany();
            return;
          }
        }

        // 캐시가 없거나 만료된 경우 새로 데이터를 로드
        const config = await this.$store.dispatch("keyValue/LOAD_CONFIG", {
          key: "기본처리부서",
        });

        if (config) {
          const cacheData = {
            data: config,
            timestamp: new Date().getTime(),
          };
          localStorage.setItem(cacheKey, JSON.stringify(cacheData));
          this.defaultDocumentCompanyInfo = config;
          this.isDefaultDocumentCompanyLoaded = true;
          this.trySetDefaultDocumentCompany();
        }
      } catch (error) {
        console.error("기본 처리부서 정보 로드 실패:", error);
        this.isDefaultDocumentCompanyLoaded = true; // 에러가 발생해도 로드 완료로 표시
      }
    },

    /**
     * 기본 처리부서 자동 설정을 시도한다
     */
    trySetDefaultDocumentCompany() {
      // 처리부서를 쓰지 않는 게시판이면 자동 지정하지 않는다
      if (!this.useDocumentCompany) return;
      // 신규작성이거나 임시작성일 경우에만 자동 설정
      if ((!this.board.statusCode || this.board.statusCode === 'temp') && this.defaultDocumentCompany) {

        this.documentCompany = {
          id: this.defaultDocumentCompany.id,
          label: this.defaultDocumentCompany.com_name,
          code: this.defaultDocumentCompany.code,
          full_label: this.defaultDocumentCompany.full_name,
          virtual_company_id: this.defaultDocumentCompany.id, // virtual_company_id 추가
        };

        this.board.documentCompany = JSON.parse(JSON.stringify(this.documentCompany));
      }
    },

    /**
     * 현재 결재 순서가 처리부서 순서인지 확인한다
     */
    isDocumentCompanyTurn() {
      // 처리부서 정보가 없으면, 검사할 필요 없음
      if (!this.documentCompany) {
        return false;
      }

      // 처리부서 결재자 정보가 없어야 한다.
      if (this.documentCompanyMembers && this.documentCompanyMembers.length > 0) {
        return false;
      }

      // 마지막 결재자가 "승인" 한 상태여야 한다.
      const lastApproval = this.approvalLine.filter((item) => item.type_code === "approval").slice(-1)[0];
      if (!lastApproval) {
        return false;
      } else if (lastApproval.status_id !== 2/*2:승인*/) {
        return false;
      }

      return true;
    },
    getDate(date) {
      return new Date(date).format("yyyy-MM-dd");
    },
    getTime(date) {
      return new Date(date).format("HH:mm:ss");
    },
    summitApprovalLine(index) {
      const list = this.approvalLine.slice().reverse();
      if (list.filter((item) => item.type_code === "approval" && item.status_id === 3).length > 0) {
        // 반려된 결재자의 index
        const rejectItemIndexes = list.map((item, index) => {
          return item.type_code === "approval" && item.status_id === 3 ? index : -1;
        })
          .filter(index => index !== -1);
        return rejectItemIndexes[0] <= index;
      }

      return true
    },
    initApprovalList(line, documentCompany, referenceCompanies) {
      this.approvalLine = [];
      this.nowChecker = {};
      this.referenceCount = 0;
      this.circulationCount = 0;
      let showStatusTag = true; // 결재 상태 태그를 표시할지 여부 (반려된 결재자 이후는 표시하지 않는데 사용)
      for (const member of line) {
        if (member.type_code !== "register") {
          if (member.type_id === 3 && member.status_id === 1 && Object.keys(this.nowChecker).length === 0) {
            this.nowChecker = member;
            member.nowChecker = true;
          }

          if (member.type_code === "reference") {
            this.referenceCount += 1;
          }

          if (member.type_code === "circulation") {
            this.circulationCount += 1;
          }

          if (member.document_company_id) {
            this.documentCompanyCount += 1;
          }

          this.approvalLine.push({
            document_company_id: member.document_company_id,
            document_company_code: member.document_company_code,
            comments: member.comments,
            company_id: member.company_id,
            company_name: member.company_name,
            section: member.section,
            department: member.department,
            status_code: member.status_code,
            status_id: member.status_id,
            status_name: member.status_name,
            type_code: member.type_code,
            type_id: member.type_id,
            type_name: member.type_name,
            user_id: member.user_id,
            user_name: member.user_name,
            position: member.position,
            rank: member.rank,
            updated_at: member.updated_at,
            show_status_tag: showStatusTag,
            nowChecker: member.nowChecker || false,
          });

          // 결재자가 반려되었을 경우, 결재자 이후의 결재자는 상태를 표시하지 않는다.
          if (member.status_id === 3) {
            showStatusTag = false;
          }
        } else {
          this.상신자 = member;
        }
      }

      this.documentCompany = documentCompany;
      this.referenceCompanies = referenceCompanies;
    },

    getStatusNum(member, status_id) {
      // 1 : 대기
      // 2 : 승인
      // 3 : 반려
      // 4 : 결재중

      if ([2, 3].includes(status_id)) {
        return status_id;
      }

      let classNum = status_id;

      if (member.nowChecker && status_id !== 5) {
        if (this.board.savable) {
          classNum = 1;
        } else {
          classNum = 4;
        }
      }
      return classNum;
    },

    getStatusName(classNum) {
      if (classNum === 1) {
        return "대기";
      } else if (classNum === 2) {
        return "승인";
      } else if (classNum === 3) {
        return "반려";
      } else if (classNum === 4) {
        return "결재중";
      }
    },

    // full_label을 ">" 기호로 연결하여 표시
    getFullPathWithArrow(fullPath) {
      if (!fullPath) return "";

      // 배열인 경우 처리
      if (Array.isArray(fullPath)) {
        // 첫 번째 요소(0번째)를 제외하고 ">" 기호로 연결
        return fullPath.slice(2).join(" > ");
      }

      // 문자열인 경우 처리
      return fullPath.replace(/\\/g, " > ");
    },

    showApprovalPopup() {
      this.showPopup = true;
    },

    handleCloseApprovalPopup() {
      this.showPopup = false;
    },

    handleSendApprovalProcess(approvalList, documentCompany, referenceDocumentCompanies) {
      this.initApprovalList(approvalList, documentCompany);
      this.$emit("handleSendApprovalProcess", approvalList, documentCompany, referenceDocumentCompanies);
    },

    handleClickUpload() {
      this.$emit("handleClickUpload");
    },

    handleClickOk() {
      this.$emit("handleClickOk");
    },

    handleClickNo() {
      this.$emit("handleClickNo");
    },

    handleAddComment() {
      this.$emit("handleAddComment", this.comment);
    },

    // 댓글 조회
    async loadCommentList(cacheDisabled) {
      const boardSlug = this.board.slug;
      const postId = this.$route.params.postId;

      if (boardSlug && postId && postId !== "create") {
        await this.$store.dispatch("board/LOAD_COMMENT_LIST", {
          boardSlug,
          postId,
          cacheDisabled,
        })
        this.commentList = JSON.parse(JSON.stringify(this.$store.state.board.commentList));
      }
    },

    // 댓글 추가
    async addComment() {
      UiUtil.loading(true);
      const boardSlug = this.board.slug;
      const postId = this.$route.params.postId;
      const comment = this.comment;
      await this.$store.dispatch("board/ADD_COMMENT", {
        boardSlug,
        postId,
        comment,
      });
      this.comment = "";

      // 댓글 리스트 새로고침
      await this.loadCommentList(true);
      UiUtil.loading(false);
    },

    // 댓글 수정
    updateCommentMode(_commentId, _comment) {
      this.isCommentUpdateMode = true;
      this.updateCommentId = _commentId;
      this.comment = _comment;
    },
    updateCommentModeCancel() {
      this.isCommentUpdateMode = false;
      this.updateCommentId = 0;
      this.comment = "";
    },
    async updateComment() {
      UiUtil.loading(true);
      const boardSlug = this.board.slug;
      const postId = this.$route.params.postId;
      const comment = this.comment;
      const commentId = this.updateCommentId;

      await this.$store.dispatch("board/UPDATE_COMMENT", {
        boardSlug,
        postId,
        comment,
        commentId,
      });
      // 댓글 리스트 새로고침
      await this.loadCommentList(true);
      this.updateCommentModeCancel();
      UiUtil.loading(false);
    },

    // 댓글 삭제
    async deleteComment(_commentId) {

      UiUtil.loading(true);
      const boardSlug = this.board.slug;
      const postId = this.$route.params.postId;
      const commentId = _commentId;
      if (postId <= 0) {
        return;
      }
      await this.$store.dispatch("board/DELETE_COMMENT", {
        boardSlug,
        postId,
        commentId,
      });

      // 댓글 리스트 새로고침
      await this.loadCommentList(true);
      UiUtil.loading(false);
    },

    getSectionDepartment(writer) {
      const section = writer.section ? writer.section : "";
      const department = writer.department ? writer.department : "";

      if (section && department) {
        if (section === department) {
          return section;
        } else {
          return `${section} ${department}`;
        }
      } else if (section) {
        return section;
      } else if (department) {
        return department;
      } else if (writer.company_name) {
        // 부서 정보가 없는 인원(일용직 등)은 사용자 검색 팝업과 같이 소속 업체명을 표기한다
        return writer.company_name;
      } else {
        return "-";
      }
    },
  },
};
</script>

<style scoped>
.date {
  font-weight: 500;
  color: #666;
}
.time {
  color: #9ca0a4;
}
.btn-border {
  font-size: 12px;
  width: 55px;
  border-radius: 999px;
  display: inline-block;
  text-align: center;

  border: 1px solid #00b812;
}

.btn-border-0 {
  border-color: #00b812;
  color: #00b812;
}

.btn-border-1 {
  border-color: #ffa84c;
  color: #ffa84c;
}

.btn-border-2 {
  border-color: #a0a0a0;
  color: #a0a0a0;
}

.btn-border-3 {
  border-color: #1e0d61;
  color: #1e0d61;
}

.btn-border-4 {
  border-color: #f60000;
  color: #f60000;
}

.btn-border-5 {
  border-color: #001aff;
  color: #001aff;
}

.btn-border-6 {
  border-color: #6ca7ff;
  color: #6ca7ff;
}

.btn-border-7 {
  border-color: #353535;
  color: #353535;
}

.btn-border-8 {
  border-color: #7e72f2;
  color: #7e72f2;
}

.side-item {
  font-size: 14px;
}

.side-item h5 {
  font-size: 14px;
}

.side-item-title {
  border-bottom: 1px solid #a0a0a0;
}
</style>
